import { useParams } from "react-router-dom";
import { useGetDocumentManagementFileByIdQuery } from "services/document-management-api";
import { useToken } from "utils/context";

export const useDocumentManagementFileData = () => {
  const { accessToken } = useToken();
  const { documentManagementFileId } = useParams<{
    documentManagementFileId?: string;
  }>();
  const {
    data: documentManagementFileData,
    isLoading,
    error,
    refetch,
  } = useGetDocumentManagementFileByIdQuery(
    { documentManagementFileId: documentManagementFileId || "" },
    { skip: !documentManagementFileId || !accessToken },
  );

  return {
    documentManagementFileData,
    workspaceUrl: documentManagementFileData?.workspace_url,
    fileId: documentManagementFileData?.file?.id,
    isLoading,
    error,
    refetch,
  };
};
